module.exports = __webpack_public_path__ + "static/media/typewriter-key-1.17263478.mp3";